import { Outlet, Link } from "react-router-dom";
import styles from "./AuthLayout.module.css";

/**
 * AuthLayout — centered card layout for auth pages.
 * Replaces Next.js /auth/layout.tsx.
 */
export function AuthLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <Link to="/">
            <span className={styles.logoText}>VNP Workplace</span>
          </Link>
        </div>
        <Outlet />
      </div>
      <p className={styles.footer}>
        © {new Date().getFullYear()} VNPay. All rights reserved.
      </p>
    </div>
  );
}
